export default "__VITE_ASSET__DQ8_h67N__"